const locationsNzConfig = () => ({
  UseNzAddressLookUpApi: false
});

export default locationsNzConfig;
